/**
 *
 * @Desc   Axios 封装
 */
import axios from 'axios'
import Vue from 'vue'
import qs from 'qs'
import router from '@/router'
import { Loading , MessageBox  } from 'element-ui'
localStorage.setItem("html", 'http://'+window.location.hostname+'/seller/#/');
// localStorage.setItem("http", 'https://educost.hnyxkf.com/fund');
// localStorage.setItem("https", 'https://openapi.cost.xiaoshouladashou.cn/fund');
localStorage.setItem("https", 'http://220.202.73.43:6604/fund');
// localStorage.setItem("html", 'http://kcpj.kechengzhijia.com/seller/#/');
let loading;

function startLoading() {
  loading = Loading.service({
    lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}

function endLoading() {
  loading.close()
}
export const TIME_OUT = 88888888; // 请求超时时间
// formData 格式
let fdHeaders = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
}
// json格式 payload
let jsonHeaders = {
  'Content-type': 'application/json;charset=UTF-8',
  'X-Requested-With': 'XMLHttpRequest',
}
//
axios.defaults.timeout = TIME_OUT;
// 创建一个新的axios实例
let http = axios.create({
  // baseURL: 'http://api.test.51qr.net/',
  // baseURL: 'http://api.51shetuan.com/',
  // baseURL: 'http://api-xueming.51qr.net:5000/',
  baseURL: 'https://api.kechengzhijia.com',
  // baseURL: process.env.API_HOST,
  headers: jsonHeaders,
  withCredentials: false,
  // 返回数据类型

  responseType: 'json',
  // responseType:'blob',
  paramsSerializer: function (params) {
    return qs.stringify(params);
  },
})

// 添加请求拦截器
http.interceptors.request.use(config => {
  // 添加token

  let token = localStorage.getItem("token");
  if (token&&!config.token) {
      config.headers.common['token'] =  token
  } ;
  showFullScreenLoading(config)
  return config
}, err => {
  return Promise.reject(err)
})


// 添加响应拦截器
http.interceptors.response.use(response => {
  tryHideFullScreenLoading();
  if (response.status === 200&&response.data) {
    const res = response.data;  // 该处可将后端数据取出，提前做一个处理
		if (res.code==200) {
      response.data.rtdata = response.data.rtdata?response.data.rtdata:[];
			return response;
      // let objs = {
      //   data:{
      //     rtdata : response.data.rtdata?response.data.rtdata:[],
      //     rtcount : response.data.rtcount,
      //     msg : response.data.msg,
      //     code : response.data.code ,
      //   }
      // } // 该处将结果返回，下一步可用于前端页面渲染用
		} else {
      Interceptor(res)
      var obj = {
        msg : response.data.msg,
        code : response.data.code
      }  ;
			return Promise.reject(obj)
		}
  }
  // return response ;
}, (error) => {
  if (error.response) {
    Interceptor(error.response.status)
  }
  return Promise.reject(error)
}
)
let needLoadingRequestCount = 0

export function showFullScreenLoading(config) {
  if (needLoadingRequestCount === 0 && config.loding != "hide") {
    startLoading()
  }
  needLoadingRequestCount++
}

// export function tryHideFullScreenLoading() {
//   if (needLoadingRequestCount <= 0) return
//   needLoadingRequestCount--
//   if (needLoadingRequestCount === 0) {
//     endLoading()
//   }
// }
export function tryHideFullScreenLoading() {
  if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
  if (needLoadingRequestCount === 0) {
    setTimeout(() => {
      if(loading){
        loading.close() ;
      }
      // tryCloseLoading;
    }, 600)
  }
}
//拦截器状态
 function Interceptor(data) {
  var i = data.code;
  console.log(router)
  let that = this;

  switch (i) {
    case 401:
        if(router.currentRoute.name){
          let xhlds = localStorage.getItem("xhlds");
          if(xhlds==1){
            return
          }
          //跳转回login路由，并把目标路由的url路径保存在login的query中
          router.replace({
            path: '/login',
            query: {back: router.currentRoute.fullPath}
          })
        }else{
          let xhlds = localStorage.getItem("xhlds");
          if(xhlds==1){
            return
          }
          /* 普通401拦截直接返回到登录页面 */
          router.push('/login');
          localStorage.clear();
        }
        break
      case 402:
          MessageBox('您的账号已在别处登录', '提示', {
            confirmButtonText: '确定',
            showClose:false,
            distinguishCancelAndClose: false,
          }).then(()=>{
            localStorage.clear();
            router.push('/login');
          }).catch(()=>{
            localStorage.clear();
            router.push('/login');
          })
        break
      case 403:
       MessageBox('您的账号在该区域无法使用', '提示', {
          confirmButtonText: '确定',
          showClose:false,
          distinguishCancelAndClose: false,
        }).then(()=>{
          localStorage.clear();
          router.push('/login');
        }).catch(()=>{
          localStorage.clear();
          router.push('/login');
        })
        break
    case '90007':
        localStorage.clear();
        router.push('/login');
        break;
  }
}
// //refreshToken
// function getrefreshToken(){
//   axios({
//     method:'post',
//     url: '/users/refresh_token',
//     data: {
//       token : localStorage.getItem('token')
//     }
//   })
//   return {token:'tokesdaohdsfgsdjfsdjkfsdfjdshfgjhksdfgsdfjksgdfjsgfjskfgsjdfgsfdgsfagf'}
// };

// 导出 为插件
export default {
  install() {
    Vue.prototype.$http = http
    Vue.http = http
  }
}

// 导出axios
export { http as axios };



// WEBPACK FOOTER //
// ./src/api/axios.js